import { render, staticRenderFns } from "./MoreAccessorials.vue?vue&type=template&id=6fdc9664&scoped=true"
import script from "./MoreAccessorials.vue?vue&type=script&lang=js"
export * from "./MoreAccessorials.vue?vue&type=script&lang=js"
import style0 from "./MoreAccessorials.vue?vue&type=style&index=0&id=6fdc9664&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fdc9664",
  null
  
)

export default component.exports